import jsPDF from 'jspdf'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import {
  Certificate,
  FontKunstlerScript,
  FontOldEnglishStd,
  FontAGaramondProSemiboldItalic,
  LogoEthos,
  QRCode,
} from '@/utils/base64'

const createCertificate = (data) => {
  const {
    courseName,
    courseLogo,
    instructorName,
    courseType,
    studentName,
    description,
    generatedAt,
    key,
  } = data.certificate

  // eslint-disable-next-line new-cap
  const doc = new jsPDF('landscape', 'mm', 'a4')

  /* Modelo */
  doc.addImage(`data:image/jpg;base64,${Certificate}`, 'JPG', 0, 0, 297, 210)

  /* Fonte: OldEnglishStd */
  doc.addFileToVFS('OldEnglishStd.ttf', FontOldEnglishStd)
  doc.addFont('OldEnglishStd.ttf', 'OldEnglishStd', 'normal')
  doc.setFont('OldEnglishStd')

  /* Cor da Fonte */
  doc.setTextColor(69, 56, 47)

  /* Nome do Curso */
  if (courseName.length < 40) {
    doc.setFontSize(30)
    doc.text(courseName, doc.internal.pageSize.getWidth() / 2, 70, {
      align: 'center',
    })
  } else {
    doc.setFontSize(28)
    const splitCourseName = doc.splitTextToSize(courseName, 170)
    doc.text(splitCourseName, doc.internal.pageSize.getWidth() / 2, 64, {
      align: 'center',
    })
  }

  /* Fonte: Kunstler-Script */
  doc.addFileToVFS('Kunstler-Script.ttf', FontKunstlerScript)
  doc.addFont('Kunstler-Script.ttf', 'Kunstler', 'normal')
  doc.setFont('Kunstler')

  /* Nome do Aluno */
  doc.setFontSize(75)
  if (studentName.length > 22) {
    doc.setFontSize(60)
  }
  if (studentName.length > 32) {
    doc.setFontSize(55)
  }
  if (studentName.length > 50) {
    doc.setFontSize(40)
  }
  doc.text(studentName, doc.internal.pageSize.getWidth() / 2, 108, {
    align: 'center',
  })

  /* Fonte: AGaramondPro-SemiboldItalic */
  doc.addFileToVFS(
    'AGaramondPro-SemiboldItalic.ttf',
    FontAGaramondProSemiboldItalic,
  )
  doc.addFont(
    'AGaramondPro-SemiboldItalic.ttf',
    'AGaramondProSemiboldItalic',
    'normal',
  )
  doc.setFont('AGaramondProSemiboldItalic')

  /* Descrição */
  doc.setFontSize(14)
  const splitDescription = doc.splitTextToSize(description, 180)
  doc.text(splitDescription, doc.internal.pageSize.getWidth() / 2, 122, {
    align: 'center',
  })

  /* Instrutor */
  doc.setFontSize(7)
  if (instructorName.length > 32) {
    doc.setFontSize(6.5)
  }
  doc.text(197, 174.5, instructorName)

  /* Data de Geração */
  doc.setFontSize(7)
  doc.text(211.7, 178.9, dateTimeSqlToDateTimeBR(generatedAt))

  /* Chave */
  doc.setFontSize(7)
  doc.text(207.7, 183, key)

  /* QRCode */
  doc.addImage(`data:image/png;base64,${QRCode}`, 'PNG', 247, 149.5, 18, 18)

  /* Logo do Curso */
  if (courseLogo != null) {
    doc.addImage(`data:image/png;base64,${courseLogo}`, 'PNG', 139, 151, 18, 18)
  }

  /* Logo da Ethos */
  if (courseType === '1') {
    doc.addImage(`data:image/png;base64,${LogoEthos}`, 'PNG', 37, 165)
  }

  if (data.type === 'view') {
    return doc.output('datauristring')
  }
  return doc.save('Certificado.pdf')
}

export default createCertificate
